import React, { useState, useEffect } from 'react'

const ERROR_IMG_SRC =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgiIGhlaWdodD0iODgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBvcGFjaXR5PSIuMyIgZmlsbD0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIzLjciPjxyZWN0IHg9IjE2IiB5PSIxNiIgd2lkdGg9IjU2IiBoZWlnaHQ9IjU2IiByeD0iNiIvPjxwYXRoIGQ9Im0xNiA1OCAxNi0xOCAzMiAzMiIvPjxjaXJjbGUgY3g9IjUzIiBjeT0iMzUiIHI9IjciLz48L3N2Zz4KCg=='

export function ImageWithFallback(props: React.ImgHTMLAttributes<HTMLImageElement>) {
  const [didError, setDidError] = useState(false)
  const [fallbackTried, setFallbackTried] = useState(false)
  const [activeSrc, setActiveSrc] = useState(props.src || '')

  // Reset error state and active source whenever props.src changes
  useEffect(() => {
    setDidError(false)
    setFallbackTried(false)
    setActiveSrc(props.src || '')
  }, [props.src])

  const handleError = () => {
    // If primary src was cards.scryfall.io and failed, attempt api.scryfall.com named image proxy as backup
    if (!fallbackTried && props.alt) {
      setFallbackTried(true)
      const cleanAlt = props.alt.includes(' // ') ? props.alt.split(' // ')[0] : props.alt
      const backupUrl = `https://api.scryfall.com/cards/named?exact=${encodeURIComponent(cleanAlt.trim())}&format=image`
      if (activeSrc !== backupUrl) {
        setActiveSrc(backupUrl)
        return
      }
    }
    setDidError(true)
  }

  const { src, alt, style, className, ...rest } = props

  if (!activeSrc) {
    return (
      <div
        className={`inline-block bg-gray-900/40 animate-pulse text-center align-middle ${className ?? ''}`}
        style={style}
      >
        <div className="flex items-center justify-center w-full h-full text-white/20 text-[9px]">
          Loading...
        </div>
      </div>
    )
  }

  return didError ? (
    <div
      className={`inline-block bg-gray-800 text-center align-middle ${className ?? ''}`}
      style={style}
    >
      <div className="flex items-center justify-center w-full h-full">
        <img src={ERROR_IMG_SRC} alt="Error loading image" {...rest} data-original-url={props.src} />
      </div>
    </div>
  ) : (
    <img src={activeSrc} alt={alt} className={className} style={style} referrerPolicy="no-referrer" {...rest} onError={handleError} />
  )
}
